export default __webpack_public_path__ + "static/media/unevenComplexion.b50ba65d.svg";